import { AIRTABLE, APP_WRITE, NOTION, SUPABASE, XANO, pluginCode } from 'drapcode-constant';
import _ from 'lodash';
import { localStorageKey } from './constant';

const environmentFixKey = 'environment_variable.';
const tenantFixKey = 'current_tenant.';

export const parseExtractPluginCode = (plugins, from) => {
  if (!plugins || plugins.length === 0) {
    return [];
  }
  plugins = plugins.map((plugin) => plugin.code);
  const pluginHeaders = [];
  let filter = [];
  if (from === 'DATASOURCE') {
    filter = [AIRTABLE];
  } else if (from === 'COLLECTIONS') {
    filter = [AIRTABLE, XANO, NOTION, APP_WRITE, SUPABASE];
  } else if (from === 'EXTERNALAPI') {
    filter = [XANO, APP_WRITE, SUPABASE, AIRTABLE];
  }
  plugins.forEach((pluginCode) => {
    if (filter.includes(pluginCode)) {
      pluginHeaders.push(pluginCode);
    }
  });
  return pluginHeaders;
};

export const prepS3Url = (plugins, projectDetail, isDefault = false) => {
  if (isDefault) {
    return process.env.REACT_APP_S3_URL;
  }
  if (!projectDetail) {
    return process.env.REACT_APP_S3_URL;
  }
  const s3Plugin = plugins.find((plugin) => plugin.code === pluginCode.AWS_S3);

  if (!s3Plugin) {
    return process.env.REACT_APP_S3_URL;
  }

  let envStr = localStorage.getItem(localStorageKey.ENVIRONMENT);
  const { environments } = projectDetail;
  const environment = environments.find((env) => env.envType === envStr);

  let { bucket_name, region } = s3Plugin.setting;
  bucket_name = replaceValueFromSource(bucket_name, environment, null);
  region = replaceValueFromSource(region, environment, null);
  return `https://${bucket_name}${region === 'us-east-1' ? '' : `.${region}`}.s3.amazonaws.com/`;
};

const replaceValueFromSource = (variableName, environment, tenant) => {
  if (variableName && typeof variableName === 'string') {
    if (variableName.startsWith(environmentFixKey)) {
      return replaceValueFromEnvironment(variableName, environment);
    } else if (variableName.startsWith(tenantFixKey)) {
      return replaceValueFromTenant(variableName, tenant);
    } else {
      return variableName;
    }
  } else {
    return variableName;
  }
};

const replaceValueFromEnvironment = (variableName, environment) => {
  if (
    variableName &&
    typeof variableName === 'string' &&
    variableName.startsWith(environmentFixKey) &&
    environment &&
    environment.constants
  ) {
    const envConstant = environment.constants.find(
      (env) => env.name === variableName.replace(environmentFixKey, ''),
    );
    return envConstant.value;
  } else {
    return variableName;
  }
};

const replaceValueFromTenant = (variableName, tenant) => {
  if (!tenant) {
    return variableName;
  }
  variableName = variableName.replace(tenantFixKey, '');
  return _.get(tenant, variableName);
};

export const getFieldOptionsForMultiTenantPlugin = (selectedCollectionId, collections) => {
  const options = [];
  const collection =
    selectedCollectionId &&
    collections.find((collection) => collection.uuid === selectedCollectionId);
  const collectionFields = collection
    ? collection.fields.filter((field) => ['text', 'uuid'].includes(field.type))
    : '';
  collectionFields &&
    collectionFields.map((field) =>
      options.push({
        value: `${field.fieldName}`,
        label: `${field.fieldTitle['en']}`,
      }),
    );
  return options;
};
